export const PATH = {
  ROOT: "/",
  HOME: "home",
  ALL_ASSET: "all-assets",
  MY_FILES: "my-files",
  ALL_FORMS: "all-forms",
  ALL_WORKFLOWS: "all-workflows",
  ALL_SEQUENCES: "all-sequences",
  ALL_TABLES: "all-tables",
  ALL_EMAILS: "all-emails",
  ALL_CAMPAIGNS: "all-campaigns",
  CAMPAIGN_NEW: "campaigns/new",
  CAMPAIGN_DETAIL: "campaigns/:campaignId",
  SENDING_DOMAINS: "sending-domains",
  SUPPRESSION_LIST: "suppression-list",
  ALL_PORTALS: "all-portals",
  ALL_PROJECTS: "all-projects",
  CREATE_WORKSPACE: "create-workspace",
  SELECT_WORKSPACE: "select-workspace",
  SETTINGS: "settings",
  VIEW_ASSET: "view-asset",
  TRASH: "trash",
  MARKETPLACE: "marketplace",
  MARKETPLACE_FORMS: "forms",
  MARKETPLACE_WORKFLOWS: "workflows",
  MARKETPLACE_TABLES: "tables",
  MARKETPLACE_EMAIL: "email",
  MARKETPLACE_RECIPES: "recipes",
  BLUEPRINTS: "marketplace",
  BLUEPRINT_DETAIL: "marketplace/:blueprintId",
  BLUEPRINT_INSTALL: "marketplace/:blueprintId/install",
  MY_TEMPLATES: "marketplace/my-templates",
  FORM_RESPONSES: "form-responses",
  FORM_ANALYTICS: "analytics",
  ANALYTICS_DASHBOARD: "dashboard",
  ANALYTICS_RESPONSE_SUMM: "summary",
  CONNECTIONS: "connections",
  SEARCH: "search",
  EXECUTION_HISTORY: "execution-history",
  REFERRAL_AND_CREDITS: "referral-&-credits",
  PROFILE: "profile",
  PASSWORD: "password",
  PRICING_PLAN: "pricing-plan",
  PLANS_AND_BILLING: "plans-and-billing",
  MCP_KEYS: "mcp-keys",
  LOGOUT: "logout",
  REDIRECT: "redirect",
  AGENTS: "agents",
  AI: "ai",
  AUTOMATION: "automation",
  CREATE_AUTOMATION: "create",
  FORMS: "forms",
  TABLES: "tables",
  EMAILS: "emails",
  FAVOURITES: "favourites",
  SUBSCRIPTION_SUCCESS: "success",
  SUBSCRIPTION_CANCELLED: "cancel",
  ASSET_STATS: "asset/:assetId/stats",
  MEMBERS: "members",
  WORKSPACES: "workspaces",
  ORGANIZATION: "organization",
  ADMIN: "admin",
  ACCOUNT_SETTINGS: "account",
  SETTINGS_PROFILE: "profile",
  SETTINGS_SECURITY: "security",
  SETTINGS_BILLING: "billing",
  SETTINGS_DOMAINS: "domains",
  SETTINGS_REFERRALS: "referrals",
  SETTINGS_BETA: "beta",
  SETTINGS_DANGER: "danger",
  CREDITS: "credits",
  ONBOARDING: "onboarding",
};
